import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../../GardenPopup/DeletePopup'
import SewerageWorkNamePopup from './SewerageWorkNamePopup'
import { useAuthState } from '../../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { SeverageWorkNameDeleteAPI, SeverageWorkNameExportTableDataAPI, SeverageWorkNameTableDataAPI } from '../../../../../../../Redux/SeverageDashboardSlice/SeverageWorkNameMasterSlice'
import { SeverageWorkTypeDataDDL } from '../../../../../../../Components/CommonDDL/SeverageWorkTypeDataDDL'
import { Loading } from '../../../../../../../Helper/Loading'
import { Pegination } from '../../../../../../../Components/Pegination/Pegination'
import { SeverageWorkPeriodDataDDL } from '../../../../../../../Components/CommonDDL/SeverageWorkPeriodDataDDL'
import { SewerageWorkNameExportData } from './SewerageWorkNameExportData'


export default function SewerageWorkNameData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log(ApiFlag)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [LocationMasterPopupShow, setLocationMasterPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [SewerageMasterPopupShow, setSewerageMasterPopupShow] = useState()
    const [WorkName, setWorkName] = useState('')

    const [SeverageWorkType, setSeverageWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkPeriod, setWorkPeriod] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSewerageMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setapiFlag('Update')
        setrowData(item)
        setSewerageMasterPopupShow(true)
    }
    const handleOnCloseClick = () => {
        setSewerageMasterPopupShow(false)
        setIsClear(!IsClear)
        setapiFlag('')
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWorkName('')
        setSeverageWorkType({
            ...SeverageWorkType,
            ID: 0,
            Label: 'Select...',
        })
        setWorkPeriod({
            ...WorkPeriod,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    const handleShowImage = (img) => {
        setLocationMasterPopupShow(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_WorkNameID: 0,
            M_SW_WorkTypeID: SeverageWorkType.ID,
            M_SW_WorkPeriodID: WorkPeriod.ID,
            WorkName: WorkName,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleSeverageWorkNameExport:handleSeverageWorkNameExport
        }
        // if (WorkPeriod.ID != '0' && SeverageWorkType.ID != '0') {
        dispatch(SeverageWorkNameTableDataAPI({ data }))
        // }
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.SeverageWorkNameTableData)


    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleSeverageWorkNameExport = () => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_WorkNameID: 0,
            M_SW_WorkTypeID: SeverageWorkType.ID,
            M_SW_WorkPeriodID: WorkPeriod.ID,
            WorkName: WorkName,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        // if (WorkPeriod.ID != '0' && SeverageWorkType.ID != '0') {
        dispatch(SeverageWorkNameExportTableDataAPI({ data }))
        // }
    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.SeverageWorkNameExportTableData)

    const handleDeleteApi = (item) => {

        const data = {
            M_SW_WorkNameID: item.m_sW_WorkNameID,
            M_UserID: UserID,
            token: token,
            // Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(SeverageWorkNameDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.SeverageWorkTypeDeleteData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     // setFrom(1)
    //     // setTo(10)
    //     // handleSearch()
    // }, [SeverageWorkType.ID, WorkPeriod.ID])

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    DashboardName={DashboardName}
                    setYearValue={setYearValue}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className='data_mob'>
                            <div className="row m-1 py-1 master_border">
                                <div className='col-5'>
                                    <h5 className="ps-1 py-1">Work Name Master</h5>
                                </div>
                                <div className='col-7 mar_add'>
                                    <div className="float-end butt">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <SewerageWorkNameExportData
                                                    ExcelData={ExportTableData}
                                                    name='Work Name Master'
                                                    searchName={searchName}
                                                />
                                        }
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div>
                                    <div className="row m-0 ">
                                        <div className="col-12 py-1 rounded rounded-2 shadow"
                                            style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                            <div className="col-12">

                                                <div className="row rounded2">

                                                    {/* <div className="col-12 col-md-6 col-lg-4">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Work Name :</b></label>
                                                    <Select
                                                        // isClearable
                                                        // isRtl={isRtl}

                                                        isSearchable
                                                        maxMenuHeight={150}
                                                        value={{ value: WorkName.ID, label: WorkName.Label }}
                                                        onChange={(e) => {
                                                            e ?
                                                                setWorkName({ ...WorkName, ID: e.value, Label: e.label })
                                                                :
                                                                setWorkName({ ...WorkName, ID: 0, Label: "Select..." })

                                                        }}
                                                        options={WorkName.DDL}
                                                    />

                                                </div> */}
                                                    <div className="col-12 col-lg-3 col-md-4">
                                                        <SeverageWorkTypeDataDDL
                                                            SeverageWorkType={SeverageWorkType}
                                                            setSeverageWorkType={setSeverageWorkType}

                                                        />

                                                    </div>

                                                    <div className="col-12 col-lg-3 col-md-4">
                                                        <SeverageWorkPeriodDataDDL
                                                            WorkPeriod={WorkPeriod}
                                                            setWorkPeriod={setWorkPeriod}

                                                        />

                                                    </div>


                                                    <div className="col-12 col-lg-3 col-md-4">
                                                        <div className="form-group">
                                                            <label className="d-block" htmlFor="NameofDepartment"><b>Work Name :</b></label>
                                                            <input type="text"
                                                                className="form-control"
                                                                id="WorkName"
                                                                value={WorkName}
                                                                onChange={(e) => setWorkName(e.target.value)}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className="col-12 col-md-3 col-lg-3 mt-md-4 d-md-flex" >
                                                        <button type="button"
                                                            className="btn-clear btn btn-primary mx-2"
                                                            onClick={handleSearch}
                                                        >
                                                            Search</button>
                                                        <button type="button"
                                                            className="btn btn-outline-danger"
                                                            onClick={handleClear}
                                                        >
                                                            Clear</button>
                                                    </div>
                                                </div>
                                                <div className="row mob_table  table-responsive pt-2">
                                                    <table id="totalordergenerated"
                                                        cellPadding="0"
                                                        cellSpacing="0"
                                                        border="0"
                                                        className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="sr_no_col">Sr No.</th>
                                                                <th>Work Type</th>
                                                                <th>Work Period</th>
                                                                <th>Work Name</th>
                                                                <th>Bench Mark (Days)</th>
                                                                <th>Penalty Description</th>
                                                                <th>Penalty Amount(Rs)</th>
                                                                <th className='action-col'>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                    <tr style={{ width: '100%' }}>
                                                                        <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                        <td>{item.workType ? item.workType : '-'}</td>
                                                                        <td>{item.m_sW_WorkPeriod ? item.m_sW_WorkPeriod : '-'}</td>
                                                                        <td className='min-w-200 min-w-350'>{item.workName ? item.workName : '-'}</td>
                                                                        <td className='int-val-col'>{item.benchMarks ? item.benchMarks : '0'}</td>
                                                                        <td>{item.penaltyDescription ? item.penaltyDescription : '-'}</td>
                                                                        <td className='amount-col'>{item.penaltyAmount ? item.penaltyAmount.toFixed(2) : '0.00'}</td>
                                                                        <td style={{ textAlign: "center", width: '7%' }}>

                                                                            {/* <SewerageWorkNamePopup
                                                                                    open={SewerageMasterPopupShow}
                                                                                    handleIsPost={handleIsPost}
                                                                                    item={item}
                                                                                    Flag='Update'
                                                                                /> */}
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                            <span>
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                    item={item}
                                                                                />
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                )) :
                                                                <td colSpan={15}>No data found</td>
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                                {tableData && tableData.table && tableData.table.length > 0 &&
                                                    <Pegination
                                                        PerPageCount={PerPageCount}
                                                        TotalCount={tableData.table[0].totalCount}
                                                        setFrom={setFrom}
                                                        setTo={setTo}
                                                        setrowNo={setrowNo}
                                                        CurrentPage={CurrentPage}
                                                        setCurrentPage={setCurrentPage}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        SewerageMasterPopupShow ?
                            <SewerageWorkNamePopup
                                open={SewerageMasterPopupShow}
                                popupHeading="Work Name Data"
                                handleIsPost={handleIsPost}
                                handleOnCloseClick={handleOnCloseClick}
                                Flag={apiFlag}
                                rowData={rowData}
                            />
                            : <></>
                    }
                </div >
            </div >
        </>
    )
}